import { render, staticRenderFns } from "./text-ellipsis.vue?vue&type=template&id=8fad92f8&scoped=true&"
import script from "./text-ellipsis.vue?vue&type=script&lang=js&"
export * from "./text-ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./text-ellipsis.vue?vue&type=style&index=0&id=8fad92f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fad92f8",
  null
  
)

export default component.exports